import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethodType } from '@platform-frontend/marketplace';
import { Observable, of } from 'rxjs';
import { CommonPaymentWordingPipe } from './common-payment-wording.pipe';

@Pipe({
  name: 'paymentMethodTypeWording'
})
export class PaymentMethodTypeWordingPipe implements PipeTransform {
  constructor(private commonPaymentWordingPipe: CommonPaymentWordingPipe) {}

  transform(value: PaymentMethodType): Observable<string> {
    switch (value) {
      case 'APPLE_PAY':
        return this.commonPaymentWordingPipe.transform('applePay');
      case 'CREDIT_CARD':
        return this.commonPaymentWordingPipe.transform('creditCard');
      case 'DIRECT_DEBIT':
        return this.commonPaymentWordingPipe.transform('sepaDirectDebit');
      case 'GOOGLE_PAY':
        return this.commonPaymentWordingPipe.transform('googlePay');
      case 'PAY_PAL':
        return this.commonPaymentWordingPipe.transform('payPal');
      case 'TEAM_BUDGET':
      default:
        return of('');
    }
  }
}
